<div class="fc-list-item" *ngIf="item">
  <div class="fc-list-item__image">
    <img *ngIf="item.image" [src]="item.image" [alt]="item.text" appImageLoad />
    <mat-icon *ngIf="!item.image" svgIcon="no_image_outline">no_image_outline</mat-icon>
  </div>
  <div class="fc-list-item__text">
    <span class="fc-list-item__text-main" [class.archived]="item.archived">{{ item.text }}</span>
    <ng-container *ngIf="item.description || item.archived">
      <span class="fc-list-item__text-separator">•</span>
      <span class="fc-list-item__text-description" *ngIf="!item.archived">{{ item.description }}</span>
      <span class="fc-list-item__text-archived" *ngIf="item.archived">{{ item.archivedText }}</span>
    </ng-container>
  </div>
  <div class="fc-list-item__action">
    <mat-checkbox
      *ngIf="item.action.type === 'checkbox'"
      color="primary"
      [checked]="item.selected"
      [disabled]="disabled"
      (change)="onCheckboxChange($event)"
    >
    </mat-checkbox>
  </div>
</div>
